<template>
    <div class="business">
        <Header></Header>
        <div class="business_container business_container_bg1">
            <div class="main_content">
                <div class="business_title">SaaS类ERP解决方案</div>
                <div class="business-bg1-box">
                    <div class="business-bg1-box-title">行业背景：</div>
                    <div class="business-bg1-box-text">
                        在数字化转型浪潮下，SaaS类ERP系统已成为企业提升管理效率、优化业务流程的核心工具。SaaS平台以轻量化、按需付费的优势广泛服务于各类企业的
                        客户关系管理、人力资源管理、进销存等场景，ERP系统则深度整合企业人、财、物、产、供、销等全链条资源。随着企业业务的跨区域拓展和远程办公模式的普及，对系统单据的实时打印、跨终端协同打印、数据安全打印的需求日益迫切。快麦云打印机作为连接云端系统与物理打印的关键节点，凭借其云端部署、远程控制、多终端适配的特性，成为解决
                        SaaS类ERP打印痛点的核心设备，为企业提供高效、安全、便捷的打印体验。

                        从销售订单、采购单据到财务凭证、库存报表，SaaS类ERP系统生成的各类业务单据需要快速、准确地落地打印，快麦云打印机通过与系统的深度集成，实现了单据打印的全流程数字化管理，助力企业打破地域限制，提升业务协同效率。
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_write">
            <div class="main_content">
                <div class="business-tabs">
                    <div class="business-tab" v-for="(tab, index) in tabList" :key="tab.title + index"
                         :class="{active: activeTabIndex === index}" @click="activeTabIndex = index">
                        <img v-if="index === 0" src="../images/icon1.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon2.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon3.png" alt="icon">
                        {{ tab.tabName }}
                    </div>
                </div>
                <div class="business_title">
                    {{ tabList[activeTabIndex].title }}
                </div>
                <div class="business_subtitle"> {{ tabList[activeTabIndex].subtitle }}</div>
                <div class="business-block" v-if="tabList[activeTabIndex].beds.length === 4">
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item" v-for="(bed, index) in tabList[activeTabIndex].beds"
                         :key="bed.title+index">
                        <div class="business-block-item-title">{{ bed.title }}</div>
                        <div class="business-block-item-content">
                            <div class="business-block-item-text">{{ bed.text }}</div>
                            <img v-if="index === 0" class="business-block-item-img" src="../images/icon4.png"
                                 alt="img"/>
                            <img v-else-if="index === 1" class="business-block-item-img" src="../images/icon5.png"
                                 alt="img"/>
                            <img v-else-if="index === 2" class="business-block-item-img" src="../images/icon6.png"
                                 alt="img"/>
                            <img v-else-if="index === 3" class="business-block-item-img" src="../images/icon7.png"
                                 alt="img"/>
                        </div>
                    </div>
                </div>
                <div class="business-block2" v-else>
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item" v-for="(bed, index) in tabList[activeTabIndex].beds"
                         :key="bed.title+index">
                        <div class="business-block-item-title">{{ bed.title }}</div>
                        <div class="business-block-item-text">{{ bed.text }}</div>
                        <img v-if="index===0" class="business-block-item-img" src="../images/icon4.png" alt="img"/>
                        <img v-else-if="index===1" class="business-block-item-img" src="../images/icon5.png" alt="img"/>
                        <img v-else-if="index===2" class="business-block-item-img" src="../images/icon6.png" alt="img"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">解决方案</div>
                <div class="business_subtitle">{{ tabList[activeTabIndex].solution }}</div>
                <template v-if="activeTabIndex ===0">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/E41.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-E</span> 系列快麦云打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                配备快麦云，可实现远程配置、固件升级和任务调度
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：150mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：58-110mm<br/>
                                接口：WiFi、usb<br/>
                                日均打印量：1000-30000单<br/>
                                适用场景：跨区域企业、连锁机构的异地协同场景。
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                快麦云端管理平台
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持用户进行打印机权限管理，总部可按分支机构分配打印权限；提供单据模板自定义功能，适配不同ERP
                                系统的单据格式；实时记录打印日志，支持数据追溯和审计，保障业务合规性。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/5-1.png" alt="printer">
                    </div>
                </template>
                <template v-else-if="activeTabIndex === 1">
                    <div class="business-solution-content">
                        <img class="business-solution-content-gj-img" src="@/views/printer/images/E41.png" alt="printer">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                快麦云打印机
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持隔离和资源配额管理，避免单个打印机过度占用资源；提供打印服务监控看板，实时展示任务成功率、响应时间等指标；内置数据加密模块和日志审计系统，保障数据安全合规。
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                快麦云API
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                提供Java/Python/PHP/JS/小程序/PERL等各种语言开发SDK，支持单据模板在线设计、打印任务提交、打印任务状态及打印机状态查询等功能，可快速集成到各类SaaS平台，支持Windows/macOS/Linux/鸿蒙等PC端操作系统下的网页及桌面应用，以及iOS/Android/鸿蒙等移动端系统上的H5/小程序/及app应用。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/5-2.png" alt="printer">
                    </div>
                </template>
                <template v-else-if="activeTabIndex === 2">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/E31.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-E31G</span> 快麦云打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                工业级耐用性，部署快麦云支持异地、远程打印
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：150mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：58-110mm<br/>
                                接口：WiFi、usb<br/>
                                日均打印量：2000-5000单<br/>
                                适用场景：可集成到 ERP 系统生产车间、财务办公室等场景
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                快麦云打印机管理后台
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持可视化模板配置，用户可使用快麦云模板编辑器设计单据模板，ERP系统调用快麦API传入单据数据，快麦API负责打印指令渲染及下发打印机进行打印。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/5-3.png" alt="printer">
                    </div>
                </template>
            </div>
        </div>
        <div class="business_container business_container_white">
            <div class="main_content">
                <div class="business_title">方案优势</div>
                <div class="business-good">
                    <div class="business-good-item" v-for="(good, index) in tabList[activeTabIndex].goods"
                         :key="good.title + index">
                        <img v-if="index === 0" src="../images/icon8.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon9.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon10.png" alt="icon">
                        <img v-else-if="index === 3" src="../images/icon11.png" alt="icon">
                        <div class="business-good-item-title">{{ good.title }}</div>
                        <div class="business-good-item-text">{{ good.text }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">场景典型客户案例</div>
                <div class="business-collaborative">
                    <template v-if="activeTabIndex === 0">
                        全国性连锁零售企业通过部署快麦云打印机和打印机管理平台，实现了总部与300余家门店的单据协同打印。采购订单从生成到门店打印的响应时间从原来的
                        2 小时缩短至 10 秒，单据传输错误率降低至 0.1%，总部通过云端平台减少了 80% 的设备运维人力投入，跨区域业务协同效率提升了
                        300%。
                    </template>
                    <template v-else-if="activeTabIndex === 1">
                        电商 SaaS 平台通过集成快麦云打印 SDK 和云打印机管理系统，为平台 5
                        万家商户提供定制化打印服务。商户可自主设计订单标签模板，平台打印服务的峰值处理能力提升至每秒1000单，任务丢失率从原来的
                        5% 降至 0.01%。通过数据加密和权限管控，成功通过国家网络安全等级保护三级认证，商户对打印服务的满意度提升40%。
                    </template>
                    <template v-else-if="activeTabIndex === 2">
                        机械制造企业将快麦云打印方案集成到 ERP系统后，实现了生产与财务单据的一体化打印。生产工单打印效率提升了
                        80%，单据传递时间从 1 天缩短至 5 分钟，生产与财务数据不一致率降低了 95%。通过自动化打印和归档，财务部门每月减少了
                        60 小时的人工操作时间，IT 部门设备维护成本降低了 60%，企业整体运营效率显著提升。
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../Header.vue';

export default {
    name: "SaaS",
    components: {Header},
    data() {
        return {
            activeTabIndex: 0,
            tabList: [
                {
                    tabName: '跨区域企业单据协同打印',
                    title: '跨区域企业单据协同打印',
                    subtitle: '大型企业或连锁机构往往拥有多个分支机构、异地仓库或远程办公团队，需要通过ERP系统实现跨区域业务协同。例如，总部通过系统下达采购订单后，异地仓库需即时打印标签进行收货及标识；对标签的实时性和准确性要求极高。',
                    solution: '使用快麦云打印机/快麦云盒，即可构建跨区域单据协同打印体系，并解决SaaS类ERP高对接成本问题。',
                    beds: [
                        {
                            title: '异地打印延迟严重',
                            text: '传统打印机依赖本地网络和设备，异地单据需通过Excel、图片或PDF发送到打印机所连接的电脑端后手动打印，流程繁琐且易出现信息滞后，影响业务响应速度。'
                        },
                        {
                            title: '设备管理分散低效',
                            text: '各分支机构打印机型号不一，缺乏统一管理平台，总部无法监控设备状态，出现卡纸、缺纸等故障时难以及时排查，导致单据打印中断。'
                        },
                        {
                            title: '数据对接兼容性差',
                            text: '不同品牌打印机与SaaS类ERP系统接口适配困难，需额外开发本地对接程序，增加系统维护成本，且易出现数据传输错误。'
                        },
                    ],
                    goods: [
                        {
                            title: '云端直连实现实时打印',
                            text: 'ERP系统可以通过API与快麦云打印机进行连接打印，异地单据生成后可即时触发打印指令，无需人工干预，实现 “系统下单、异地秒打”，打破地域限制。'
                        },
                        {
                            title: '集中管理掌控全局设备',
                            text: '通过快麦云端平台，总部可实时监控所有分支机构打印机的工作状态、打印任务进度、耗材余量等信息，远程诊断并处理设备故障，降低运维成本。'
                        },
                        {
                            title: '深度适配保障数据兼容',
                            text: '快麦云打印机提供标准化API接口，以及Java/Python/PHP/JS/小程序/PERL等各类语言的SDK，无需额外太多的开发即可实现数据无缝对接，确保单据信息准确传输打印。'
                        },
                    ]
                },
                {
                    tabName: 'SaaS类ERP产品多用户同时打印服务',
                    title: 'SaaS类ERP产品多用户同时打印服务',
                    subtitle: 'SaaS类ERP产品服务商需为平台上千家企业客户提供稳定的打印服务，满足不同客户的个性化单据需求，如电商类ERP的快递面单、餐饮SaaS平台的外卖小票、SaaS类CRM系统的客户合同等。平台需保障打印服务的稳定性、安全性和扩展性。',
                    solution: '为SaaS平台集成快麦云打印API和快麦云打印机，打造多客户专属打印服务模块。',
                    beds: [
                        {
                            title: '用户需求个性化难满足',
                            text: '不同企业客户的单据格式、打印规则差异大，传统打印方案难以快速适配个性化需求，导致客户体验差。'
                        },
                        {
                            title: '用户多操作员并行打印问题',
                            text: '很多ERP系统存在单个企业用户的身处不同地点的多个操作员同时打印的需求，传统打印机只能连接单台电脑或者移动设备进行打印，无法满足多端同时提交的打印任务按时排队打印的需求。'
                        },
                        {
                            title: '服务稳定性难以保障',
                            text: 'SaaS平台同时在线使用和打印的订单量波动大，订单高峰时打印请求集中爆发，易出现服务拥堵、任务丢失等问题，影响平台口碑。'
                        },
                        {
                            title: '数据安全风险高',
                            text: '单据包含企业敏感信息，打印过程中存在数据泄露风险，且缺乏有效的权限管控和日志审计机制，难以满足合规要求。'
                        },
                    ],
                    goods: [
                        {
                            title: '灵活定制适配个性需求',
                            text: '快麦云打印提供丰富的 API 接口，SaaS 平台可基于接口快速开发自定义打印模板功能，企业客户可自主设计单据格式、添加 Logo 和水印，满足个性化需求。'
                        },
                        {
                            title: '弹性扩容应对流量波动',
                            text: '采用云端分布式架构，支持动态扩容打印资源，订单高峰时自动分配更多算力处理打印任务，确保服务稳定不宕机，保障平台用户体验。'
                        },
                        {
                            title: '全程加密保障数据安全',
                            text: '打印数据从 SaaS 平台到云打印机全程采用 SSL 加密传输，用户管理系统支持细粒度权限控制，每个企业客户仅能访问自身打印任务和模板，且所有操作日志可追溯，满足数据安全合规要求。'
                        },
                    ]
                },
                {
                    tabName: 'ERP系统生产与财务一体化打印',
                    title: 'ERP系统生产与财务一体化打印',
                    subtitle: '制造业 ERP 系统涵盖生产计划、物料管理、财务管理等核心模块，需实现生产工单、领料单、入库单、发票、记账凭证等全流程单据的一体化打印，确保生产数据与财务数据的一致性和连贯性，支撑企业精细化管理和决策。',
                    solution: '在ERP系统中使用快麦云打印方案，实现生产与财务单据的自动化打印与归档。',
                    beds: [
                        {
                            title: '单据流转断裂数据不同步',
                            text: '生产部门的纸质工单与财务部门的电子数据脱节，人工传递过程中易出现单据丢失、信息篡改等问题，导致生产与财务数据不一致。'
                        },
                        {
                            title: '打印流程繁琐效率低下',
                            text: 'ERP 系统单据需手动导出后连接本地打印机打印，多部门重复操作，且单据归档需人工整理，耗时费力。'
                        },
                        {
                            title: '设备兼容性差维护困难',
                            text: '不同部门使用不同品牌打印机，与 ERP 系统兼容性差，频繁出现驱动冲突、格式错乱等问题，IT 部门维护成本高。'
                        },
                    ],
                    goods: [
                        {
                            title: '数据联动实现流程闭环',
                            text: '快麦云打印机与 ERP 系统深度集成，生产工单审核后自动触发打印，同时同步至财务模块；入库单、发票等财务单据打印时自动关联生产数据，确保业务流程闭环和数据一致性。'
                        },
                        {
                            title: '自动化打印提升效率',
                            text: '设置触发规则后，ERP 系统单据按预设条件自动打印，如生产工单审批通过后立即打印、发票生成后自动打印并推送至财务归档，减少人工操作，提升流程效率。'
                        },
                        {
                            title: '统一标准降低维护成本',
                            text: '采用标准化快麦云打印机，与 ERP 系统完美兼容，避免驱动冲突和格式问题；通过番茄打印管家集中管理设备，IT 部门可远程排查故障，降低维护成本。'
                        },
                    ]
                },
            ]
        }
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../business.scss";
</style>
